import React from 'react';
import { motion } from 'framer-motion';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { earlierRoles, roles } from '../data/profile';
export function CareerRecord() {
  return <PageShell path="/career" data-id="element-225" data-mp="d3eulwldvgi4">
      <section className="bg-white py-20 lg:py-24" aria-labelledby="appointments-heading" data-id="element-226" data-mp="h6uowm9zd4rn">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-227" data-mp="3gm82ptve7d4w">
          <div id="appointments-heading" data-id="element-228" data-mp="3go2qdfy1tjco">
            <SectionHeading eyebrow="Executive Appointments" title="Track record, in sequence" description="Each appointment listed with the mandate held and what was delivered against it." data-id="element-229" data-mp="3ll2w1pqzkk39" />
          </div>

          <ol className="mt-14 border-t border-platinum-200" data-id="element-230" data-mp="3ufr2hj8as7tn">
            {roles.map((role, index) => <motion.li key={role.organisation} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1]
          }} className="border-b border-platinum-200 py-10" data-id="element-231" data-mp="2xtxjpkk989xp" data-mpi={index}>
                <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-232" data-mp="1do16liw76nal">
                  <div className="lg:col-span-4" data-id="element-233" data-mp="18phet1uxahab">
                    <p className="font-sans text-xs font-semibold uppercase tracking-[0.16em] text-gold-600" data-id="element-234" data-mp="13rfyupssmy32">
                      {role.period}
                    </p>
                    <h3 className="mt-4 font-display text-xl font-bold leading-snug tracking-tight text-navy-900 lg:text-2xl" data-id="element-235" data-mp="zojaeigko7r7">
                      {role.title}
                    </h3>
                    <p className="mt-2 font-sans text-base font-medium text-charcoal-600" data-id="element-236" data-mp="pt7uvxxcawie">
                      {role.organisation}
                    </p>
                    {index === 0 ? <span className="mt-4 inline-flex items-center bg-navy-900 px-2.5 py-1 font-sans text-xs font-semibold uppercase tracking-[0.12em] text-gold-400" data-id="element-237" data-mp="2k6zcbjlwukoe">
                        Current
                      </span> : null}
                  </div>

                  <div className="lg:col-span-8" data-id="element-238" data-mp="8jdpmp0jo7e4">
                    <p className="border-l-2 border-gold-500 pl-5 font-sans text-base leading-relaxed text-charcoal-700" data-id="element-239" data-mp="8ghqixcynco3">
                      {role.mandate}
                    </p>
                    <ul className="mt-6 space-y-3.5" data-id="element-240" data-mp="117rmh1fwcxo3">
                      {role.achievements.map(achievement => <li key={achievement} className="flex items-start gap-3.5" data-id="element-241" data-mp="163qgb4jzv7vw">
                          <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 shrink-0 bg-gold-600" data-id="element-242" data-mp="rawpwo36p7cg" />
                          <span className="font-sans text-sm leading-relaxed text-charcoal-700 lg:text-base" data-id="element-243" data-mp="w9zuy8j5zdkf">
                            {achievement}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </motion.li>)}
          </ol>
        </div>
      </section>

      <section className="bg-platinum-100 py-20 lg:py-24" aria-labelledby="earlier-heading" data-id="element-244" data-mp="1u16es8sjyzbh">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-245" data-mp="280ef550gcdh9">
          <div id="earlier-heading" data-id="element-246" data-mp="23zca27jut77d">
            <SectionHeading eyebrow="Earlier Leadership" title="Foundational appointments" data-id="element-247" data-mp="240dmafclvzqo" />
          </div>
          <ul className="mt-10 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 sm:grid-cols-3" data-id="element-248" data-mp="1g7x8wi3tcvxp">
            {earlierRoles.map(role => <li key={role.organisation} className="flex flex-col bg-white p-8" data-id="element-249" data-mp="1p3d535s1jn6g">
                <p className="font-sans text-xs font-semibold uppercase tracking-[0.16em] text-gold-600" data-id="element-250" data-mp="1kbd0v14xu842">
                  {role.period}
                </p>
                <p className="mt-3 font-display text-base font-bold text-navy-900" data-id="element-251" data-mp="wjo3359ckrfq">
                  {role.organisation}
                </p>
                <p className="mt-2 font-sans text-sm font-medium text-charcoal-700" data-id="element-252" data-mp="15afwslgz3sti">{role.title}</p>
                <p className="mt-auto pt-4 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-253" data-mp="1a7znikuuxy2c">
                  {role.context}
                </p>
              </li>)}
          </ul>
        </div>
      </section>
    </PageShell>;
}